import Vue from 'vue';
const EventBus = new Vue(); // Yep, simple as that!
export default EventBus;
